export default __webpack_public_path__ + "static/media/pullover_end.7aaf8cd5.svg";